export default __webpack_public_path__ + "static/media/Neuroprax-Pot-ban.bf85c4aa.jpg";